import { render, staticRenderFns } from "./Uranus.vue?vue&type=template&id=035a1dc4&"
import script from "./Uranus.vue?vue&type=script&lang=js&"
export * from "./Uranus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports